import { formatCurrency, getCurrencySymbol } from '@angular/common';
import {
  AfterViewInit,
  Component,
  DEFAULT_CURRENCY_CODE,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { toNumber } from 'lodash';
import { convertKeyBoardEventDataToNumpadValue, updateCurrencyAmount } from './currency-input-calculations';



@Component({
    selector: 'app-currency-input',
    template: `
    <input type="text" class="d-block border-0 w-100 h-100 text-end" (input)="onInput($event)"
           autocomplete="off"
           inputmode="numeric"
           [disabled]="disabled"
           (focus)="alignCursorToEnd()"
           (click)="alignCursorToEnd()"
           #htmlInputElement>
  `,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CurrencyInputComponent),
            multi: true
        }],
    styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
      text-align: right;
      font-size: inherit;
    }
    input {
      border: none;
      background-color: transparent;
      resize: none;
      outline: none;
    }
  `],
    standalone: false
})
export class CurrencyInputComponent implements OnChanges, AfterViewInit {
  @Input() disabled = false;
  @Input() value = 0;
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('htmlInputElement') input!: ElementRef<HTMLInputElement>;

  rawValue = 0;

  constructor(@Inject(DEFAULT_CURRENCY_CODE) private readonly currency: string, @Inject(LOCALE_ID) private readonly locale: string) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value) {
      this.rawValue = toNumber(this.value) || 0;
      this.updateMaskedValue();
    }
  }

  ngAfterViewInit() {
    this.updateMaskedValue();
    if (this.input.nativeElement.parentElement?.hasAttribute('ngbAutofocus')) {
      this.input.nativeElement.focus();
    }
  }

  updateMaskedValue() {
    if (this.input?.nativeElement) {
      // TODO: use formatting provided in app config
      this.input.nativeElement.value = formatCurrency(this.rawValue, this.locale, getCurrencySymbol(this.currency, 'narrow'), this.currency);
    }
  }

  onInput(event: any) {
    if (!event.target) {
      return;
    }
    this.handleInputValue(event.data);
  }

  alignCursorToEnd() {
    const end = this.input.nativeElement.value.length;
    this.input.nativeElement.setSelectionRange(end, end);
  }

  private handleInputValue(inputValue: string | null) {
    this.rawValue = updateCurrencyAmount(this.rawValue, convertKeyBoardEventDataToNumpadValue(inputValue));
    this.updateMaskedValue();
    this.valueChange.emit(this.rawValue);
  }
}
